import React, { useState, useEffect } from 'react';
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import 'bootstrap/dist/css/bootstrap.min.css';
import { Typography } from '@mui/material';
import axios from 'axios';
import { getApiHeader } from 'utlis/commonfunctions';
import { toZonedTime, toDate } from 'date-fns-tz';
import Loader from 'layouts/nbn/components/loader';
import { useNavigate, useLocation } from 'react-router-dom';

const SERVER_URL = process.env.REACT_APP_API_URL;

const WorkApprovals = () => {
  const navigate = useNavigate();
  const location = useLocation(); // Use location to track route changes
  const [selectedWeek, setSelectedWeek] = useState({ start: '', end: '' });
  const [workWeek, setWorkWeek] = useState('');
  const [reviewers, setReviewers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [weekRange, setWeekRange] = useState(null);
  
  // Retrieve startDate and endDate from location state
  const { startDate, endDate } = location.state || {};

// const getWeekOptions = () => {
//   const options = [];
//   const currentDate = new Date();
//   const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
//   const localDate = toZonedTime(currentDate, timezone);
//   const currentDay = localDate.getDay();
//   const daysUntilMonday = currentDay === 0 ? -6 : 1 - currentDay;
//   localDate.setDate(localDate.getDate() + daysUntilMonday);
  
//   // Adjust the localDate to the Monday of the current week
//   for (let i = 0; i < 4; i++) {
//     const startOfWeek = new Date(localDate);
//     startOfWeek.setDate(localDate.getDate() + i * 7);
//     const endOfWeek = new Date(startOfWeek);
//     endOfWeek.setDate(startOfWeek.getDate() + 4);
      
//     const weekLabel = `${startOfWeek.toLocaleString('default', { month: 'short' })} ${startOfWeek.getDate()} - ${endOfWeek.toLocaleString('default', { month: 'short' })} ${endOfWeek.getDate()}`;

//     const dayOfWeek = startOfWeek.getDay();

//       if (dayOfWeek === 0) { 
//         const adjustedStartDate = new Date(startOfWeek);
//         adjustedStartDate.setDate(adjustedStartDate.getDate() + 1);
//         startOfWeek.setDate(adjustedStartDate.getDate());

//         const adjustedEndDate = new Date(endOfWeek);
//         adjustedEndDate.setDate(adjustedEndDate.getDate() + 1); 
//         endOfWeek.setDate(adjustedEndDate.getDate());

//         const weekRange = {
//           start: startOfWeek.setDate(adjustedStartDate.getDate()),
//           end:endOfWeek.setDate(adjustedEndDate.getDate())
//         };

//       }else {

//         const weekRange = {
//           start: toDate(startOfWeek).toISOString().split('T')[0],
//           end: toDate(endOfWeek).toISOString().split('T')[0]
//         };

//       }

//     options.push(
//       <option key={i} value={JSON.stringify(weekRange)}>
//         {weekLabel}
//       </option>
//     );
//   }

//   return options;
// };

const getWeekOptions = () => {
  const options = [];
  const currentDate = new Date();

  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  const localDate = toZonedTime(currentDate, timezone);

  const currentDay = localDate.getDay();
  const daysUntilMonday = currentDay === 0 ? -6 : 1 - currentDay; // Adjust to nearest Monday
  localDate.setDate(localDate.getDate() + daysUntilMonday);

  for (let i = 0; i < 4; i++) {
      const startOfWeek = new Date(localDate);
      startOfWeek.setDate(localDate.getDate() + i * 7);

      const endOfWeek = new Date(startOfWeek);
      endOfWeek.setDate(startOfWeek.getDate() + 4); 

      const localStartOfWeek = toZonedTime(startOfWeek, timezone);
      const localEndOfWeek = toZonedTime(endOfWeek, timezone);

      const weekLabel = `${localStartOfWeek.toLocaleString('default', { month: 'short' })} ${localStartOfWeek.getDate()} - ${localEndOfWeek.toLocaleString('default', { month: 'short' })} ${localEndOfWeek.getDate()}`;

      // const weekRange = {
      //     start: toDate(startOfWeek).toISOString().split('T')[0],
      //     end: toDate(endOfWeek).toISOString().split('T')[0] 
      // };

        const weekRange = {
            start: localStartOfWeek.toLocaleDateString('en-CA'),
            end: localEndOfWeek.toLocaleDateString('en-CA')
      };

      options.push(
          <option key={i} value={JSON.stringify(weekRange)}>
              {weekLabel}
          </option>
      );
  }

  return options;
};

  

  useEffect(() => {
    const storedStartDate = startDate;
    const storedEndDate = endDate;

    if (storedStartDate && storedEndDate) {
        // Initialize storedWeekRange with start and end dates
        let storedWeekRange = {
            start: storedStartDate,
            end: storedEndDate
        };

        const dayOfWeek = new Date(storedStartDate).getDay();

        if (dayOfWeek === 0) { // If it's Sunday
            // Adjust the start and end dates by adding one day if it's Sunday
            const adjustedStartDate = new Date(storedStartDate);
            adjustedStartDate.setDate(adjustedStartDate.getDate() + 1); // Add one day to start date
            storedWeekRange.start = adjustedStartDate.toISOString().split('T')[0];

            const adjustedEndDate = new Date(storedWeekRange.end);
            adjustedEndDate.setDate(adjustedEndDate.getDate() + 1); // Add one day to end date
            storedWeekRange.end = adjustedEndDate.toISOString().split('T')[0];
        }

        setWorkWeek(JSON.stringify(storedWeekRange));

        setWeekRange(storedWeekRange);
        setSelectedWeek(storedWeekRange);

        fetchReviewers(storedWeekRange.start, storedWeekRange.end);
    }
}, [startDate, endDate]); // Trigger the effect whenever startDate or endDate change


  const handleWeekChange = async (e) => {
    const selectedValue = e.target.value;
    if (!selectedValue) {
      
      setSelectedWeek(null);
      setWorkWeek(null);
      setWeekRange(null);
      setReviewers([]);
      return;
    }

    let newWeekRange;
    try {
      newWeekRange = JSON.parse(selectedValue);
    } catch (error) {
      console.error("Invalid JSON format in selected option:", error);
      return;
    }

    const dayOfWeek = new Date(newWeekRange.start).getDay();
    if (dayOfWeek === 0) { // Sunday
      const adjustedStartDate = new Date(newWeekRange.start);
      adjustedStartDate.setDate(adjustedStartDate.getDate() + 1); // Add one day to start date
  
      newWeekRange.start = adjustedStartDate.toISOString().split('T')[0];
  
      const adjustedEndDate = new Date(newWeekRange.end);
      adjustedEndDate.setDate(adjustedEndDate.getDate() + 1); // Add one day to end date
      newWeekRange.end = adjustedEndDate.toISOString().split('T')[0];
    }

    sessionStorage.setItem('start_date', newWeekRange.start);
    sessionStorage.setItem('end_date', newWeekRange.end);
    setWeekRange(newWeekRange);
    setSelectedWeek(newWeekRange);
    setWorkWeek(selectedValue);

    fetchReviewers(newWeekRange.start, newWeekRange.end);
  };

  const fetchReviewers = async (startDate, endDate) => {
    setLoading(true);
    const headers = await getApiHeader();
    try {
      const response = await axios.post(`${SERVER_URL}work-plan/get-work-plan-creator-list`, {
        start_date: startDate,
        end_date: endDate
      }, { headers });
      setReviewers(response.data.data.work_plan_creators);
    } catch (error) {
      console.error("Error fetching work plan data:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleViewDetails = (RetailerId, startDate, endDate) => {
    // Session is cleared automatically by the effect above

    navigate('/work_approval_edit', {
      state: {
        RetailerId,
        startDate,
        endDate
      }
    });
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <div className="container workplanform p-3">
        <Typography variant="h4" gutterBottom>Approve/Reject Work Plan</Typography>
        <div className="form-group">
          <label htmlFor="work-week" className="label">Select the Week: </label>
          <select id="work-week" name="work-week" className="select" onChange={handleWeekChange} value={workWeek}>
            <option value="">Please choose an option</option>
            {getWeekOptions()}
          </select>
        </div>

        <Typography variant="body2" color="textSecondary" gutterBottom>
          Please review and approve or reject the work plans. 
        </Typography>

        {loading ? (
          <div className="text-center">
            <Loader />
          </div>
        ) : (
          <div className="table-responsive mt-3">
            <table className="table table-bordered table-striped">
              <thead>
                <tr>
                  <th>Sl No</th>
                  <th>PID</th>
                  <th>Retailer Name</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {reviewers.length > 0 ? reviewers.map((reviewer, index) => (
                  <tr key={reviewer.retailer_id}>
                    <td>{index + 1}</td>
                    <td>{reviewer.retailer_code}</td>
                    <td>{reviewer.retailer_name}</td>
                    <td>
                      {reviewer.status === 1 ? 'Approved' :
                        reviewer.status === 2 ? 'Rejected' :
                        'Pending'}
                    </td>
                    <td>
                      {reviewer.status === 0 && (
                        <button
                          className="btn btn-danger btn-sm ms-2" style={{ backgroundColor: '#e20e75' }}
                          onClick={() => handleViewDetails(reviewer.retailer_id, weekRange?.start, weekRange?.end)}
                        >
                          View Work Details
                        </button>
                      )}
                    </td>
                  </tr>
                )) : (
                  <tr>
                    <td colSpan="5" className="text-center">No work plan found for the selected week</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </DashboardLayout>
  );
};

export default WorkApprovals;
